import Vue from "vue"
import moment from 'moment';

//本地存储一个对象
Vue.prototype.$setStorage = function (key, obj) {
    if (typeof obj === 'string') {
        localStorage.setItem(key, obj);
    } else {
        localStorage.setItem(key, JSON.stringify(obj));
    }
}

//本地获取一个对象
Vue.prototype.$getStorage = function (key) {
    let val = localStorage.getItem(key);
    try {
        return JSON.parse(val);
    } catch (e) {
        return val;
    }
}

//本地清空一个对象
Vue.prototype.$clearStorage = function (key) {
    if (key) {
        localStorage.removeItem(key);
    } else {
        localStorage.clear();
    }
}

//cascader 数据转换
Vue.prototype.$cascader = {
    value: "id",
    label: "name",
    children: "nodes",
    expandTrigger: 'hover',//鼠标悬浮展开子级框
    emitPath: false, // v-model的绑定值，直接是最后一级的value值，不包含父级
    multiple: false, //多选
    checkStrictly: true // 该属性默认为true, 即多级数据，用户只能勾选最后一级，设置为false,  用户可以选择任意一级
}

//设置列表是否多选
Vue.prototype.$multiple = function (multiple) {
    this.$cascader = {
        value: "id",
        label: "name",
        children: "nodes",
        expandTrigger: 'hover',//鼠标悬浮展开子级框
        emitPath: false, // v-model的绑定值，直接是最后一级的value值，不包含父级
        multiple: multiple, //多选
        checkStrictly: true // 该属性默认为true, 即多级数据，用户只能勾选最后一级，设置为false,  用户可以选择任意一级
    }
}

//列转换器
Vue.prototype.$colall = function (row, column, cellValue) {
    if (!Array.isArray(Vue.prototype.$dic.all)) return "";
    if (!Array.isArray(cellValue)) {
        let find = Vue.prototype.$dic.all.find((item) => {
            return item.id == cellValue;
        })
        return find ? find.name : "";
    } else {
        let value = "";
        cellValue.forEach((cellitem) => {
            let find = Vue.prototype.$dic.all.find((item) => {
                return item.id == cellitem;
            })
            value += find ? find.name : "";
            value += "、"
        })
        return value.substring(0, value.length - 1);;
    }
}

//表格时间列转换器
Vue.prototype.$coltime = function (row, column) {
    let date = row[column.property]
    if (date == undefined) {
        return ''
    }
    var datetime = moment(date).format("YYYY-MM-DD HH:mm:ss")
    if (datetime === '0001-01-01 00:00:00') return "";
    else return datetime;
}

//表格日期列转换器
Vue.prototype.$coldate = function (row, column) {
    let date = row[column.property];
    if (date == undefined) {
        return ''
    }
    return moment(date).format("YYYY-MM-DD")
}

//开启关闭列转换器
Vue.prototype.$colstate = function (row, column) {
    let data = row[column.property];
    if (data == 0) {
        return '禁用'
    } else {
        return '启用'
    }
}

//数据转换器
Vue.prototype.$transall = function (value) {
    if (!Array.isArray(Vue.prototype.$dic.all)) return "";
    if (!Array.isArray(value)) {
        let find = Vue.prototype.$dic.all.find((item) => {
            return item.id == value;
        })
        return find ? find.name : "";
    }
    else {
        let valuetemp = "";
        value.forEach((cellitem) => {
            let find = Vue.prototype.$dic.all.find((item) => {
                return item.id == cellitem;
            })
            valuetemp += find ? find.name : "";
            valuetemp += "、"
        })
        return valuetemp.substring(0, valuetemp.length - 1);;
    }
}

//时间转换器
Vue.prototype.$transtime = function (obj) {
    let date = obj
    if (date == undefined) {
        return ''
    }
    var datetime = moment(date).format("YYYY-MM-DD HH:mm:ss")
    if (datetime === '0001-01-01 00:00:00') return "";
    else return datetime;
}

//日期转换器
Vue.prototype.$transdate = function (obj) {
    let date = obj
    if (date == undefined) {
        return ''
    }
    var datetime = moment(date).format("YYYY-MM-DD HH:mm:ss")
    if (datetime === '0001-01-01 00:00:00') return "";
    else return datetime;
}

//时间快速选择
Vue.prototype.$picker = {
    shortcuts: [{
        text: '最近一周',
        onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
        }
    }, {
        text: '最近一个月',
        onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
        }
    }, {
        text: '最近三个月',
        onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
        }
    }]
}

//根据ID找出对象在数组中的INDEX
Vue.prototype.$index = function (arr, obj) {
    var i = arr.length
    while (i--) {
        if (arr[i].id === obj.id) {
            return i;
        }
    }
    return -1;
}

//选择项删除多选
Vue.prototype.$deletes = function (selection, url, list) {
    let obj = { ids: [] }
    this.$confirm("此操作将删除当前项, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
    }).then(() => {
        selection.forEach(row => { obj.ids.push(row.id); });
        this.$axios.post(url, obj).then((res) => {
            if (res.data.code === 200) list();
            else this.$message.error(res.data.msg);
        });
    })
}

//下载文件
Vue.prototype.$download = function (urls) {
    let url = this.$axios.defaults.baseURL + urls; // url
    let urlArray = url.split('/');
    let filename = urlArray[urlArray.length - 1];
    const a = document.createElement('a');
    // 将url转成blob地址。如果url是一个完整的链接，需要后端开清跨域请求
    fetch(url).then(res => res.blob())
        .then(blob => { // 将链接地址字符内容转变成blob地址
            a.href = URL.createObjectURL(blob)
            a.download = filename // 下载文件的名字
            document.body.appendChild(a)
            a.click()
        })
    this.$axios.get("/Api/DownLoad?url="+ url);
}

//导出文件
Vue.prototype.$outfile = function (table) {
    let date = obj
    if (date == undefined) {
        return ''
    }
    var datetime = moment(date).format("YYYY-MM-DD HH:mm:ss")
    if (datetime === '0001-01-01 00:00:00') return "";
    else return datetime;
}